import { TranslationModule } from "../translation/translation.module";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FooterComponent } from "./footer/footer.component";
import { HeaderComponent } from "./header/header.component";
import { SidebarMenuComponent } from "./sidebar-menu/sidebar-menu.component";
import { GlobalModule } from "../Global/global.module";

import { RouterModule } from "@angular/router";
import { ReactiveFormsModule } from "@angular/forms";
import { CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import {
  BrandsComponent as BrandsComponent,
  CategoryHomeComponent,
  FooterComponent as footerComponentBib,
  HeaderComponent as HeaderComponentBib,
  MenuComponent,
  AccountMenuComponent,
} from "admin-common";

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],

  declarations: [FooterComponent, HeaderComponent, SidebarMenuComponent],
  exports: [SidebarMenuComponent, FooterComponent, HeaderComponent],
  imports: [
    TranslationModule,
    ReactiveFormsModule,
    CommonModule,
    GlobalModule,
    footerComponentBib,
    HeaderComponentBib,
    BrandsComponent,
    CategoryHomeComponent,
    RouterModule.forChild([]),
    MenuComponent,
    AccountMenuComponent,
  ],
})
export class LayoutModule {}
